import { LinearProgressWithLabel } from "components/LinearProgressWithLabel";
import { useTranslation } from "react-i18next";

import { EpcFileUploadBase } from "./EpcFileUploadBase";

type EpcAnalyzingPhaseProps = {
  file: File;
};

export const EpcAnalyzingPhase = ({ file }: EpcAnalyzingPhaseProps) => {
  const { t } = useTranslation();
  return (
    <EpcFileUploadBase
      file={file}
      message={t("AddBuilding.epcModal.analyzingMessage")}
      progressComponent={<LinearProgressWithLabel fullWidth hasAnimation parentClassName="mt-2" value={100} />}
      title={t("AddBuilding.epcModal.analyzingTitle")}
    />
  );
};
